import $ from "jquery";
let App_Video;

App_Video = (() => {
    function App_Video() {
        $(document).ready(() => {
            let page_url;
            let player;
            let player_url;
            let postToVideo;
            let startVideo;
            let url_params;
            player = $(".video-hold iframe");
            player_url =
                window.location.protocol + player.attr("src").split("?")[0];
            page_url = window.location.href;
            url_params = page_url.split("?")[1];
            postToVideo = (action, value) => {
                let data;
                let message;
                data = {
                    method: action
                };
                if (value) {
                    data.value = value;
                }
                message = JSON.stringify(data);
                player[0].contentWindow.postMessage(data, player_url);
            };
            startVideo = () => {
                $("#reveal-video")
                    .removeClass("hidden")
                    .addClass("visible");
                postToVideo("play");
            };
            if (
                typeof url_params !== "undefined" &&
                url_params.includes("play=true")
            ) {
                startVideo();
            }
            $(".video-link").on("click", e => {
                e.preventDefault();
                return startVideo();
            });
            $(".modal-overlay").on("click", e => {
                postToVideo("pause");
            });
            $(document).on("keydown", ({ keyCode }) => {
                let esc;
                esc = 27;
                switch (keyCode) {
                    case esc:
                        postToVideo("pause");
                }
            });
        });
    }

    return App_Video;
})();

export default App_Video;
